import React from 'react';
import './style/contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { RiMessengerLine } from 'react-icons/ri'
import { BsWhatsapp } from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com';


function Contact(props) {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_h92y6ke', 'template_bm662ee', form.current, 'BxSeR21Vk3jqN7GPv')

        e.target.reset();
    };

    return (
        <section id='contact' className='box5'>
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>

            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <MdOutlineEmail className='contact__option-icon' />
                        <h4>Email</h4>
                        <h5>falefelix23@gmail.com</h5>
                        <a href="mailto:falefelix23@gmail.com" target='_blank' rel="noreferrer" >
                            Send a message
                        </a>
                    </article>
                    <article className="contact__option">
                        <RiMessengerLine className='contact__option-icon' />
                        <h4>Messenger</h4>
                        <h5>Fale Felix</h5>
                        <a href="https://m.me/felix.diwane.fale" target='_blank' rel="noreferrer">
                            Send a message
                        </a>
                    </article>
                    <article className="contact__option">
                        <BsWhatsapp className='contact__option-icon' />
                        <h4>Whatsapp</h4>
                        <h5>+22897171391</h5>
                        <a href="https://api.whatsapp.com/send?phone=+22897171391" target='_blank' rel="noreferrer">
                            Send a message
                        </a>
                    </article>
                </div>
                {/* End of contact options */}
                <form ref={form} onSubmit={sendEmail} >
                    <input type="text" name='name' placeholder='Your Full Name' required />
                    <input type="email" name='email' placeholder='Your Email' required />
                    <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
                    <button type='submit' className='btn btn-primary'>
                        Send Message
                    </button>
                </form>
            </div>
        </section>
    );
}

export default Contact;